__turbopack_context__.v({
  "belowCardSlot": "public-trials-pipeline-timeline-module__XQKmsq__belowCardSlot",
  "card": "public-trials-pipeline-timeline-module__XQKmsq__card",
  "cardBody": "public-trials-pipeline-timeline-module__XQKmsq__cardBody",
  "cardCentered": "public-trials-pipeline-timeline-module__XQKmsq__cardCentered",
  "cardHead": "public-trials-pipeline-timeline-module__XQKmsq__cardHead",
  "cardHeadActions": "public-trials-pipeline-timeline-module__XQKmsq__cardHeadActions",
  "cardHeadRow": "public-trials-pipeline-timeline-module__XQKmsq__cardHeadRow",
  "cardHeadStacked": "public-trials-pipeline-timeline-module__XQKmsq__cardHeadStacked",
  "cardHeadWithCtrlHeading": "public-trials-pipeline-timeline-module__XQKmsq__cardHeadWithCtrlHeading",
  "cardLightEmpty": "public-trials-pipeline-timeline-module__XQKmsq__cardLightEmpty",
  "cardLogo": "public-trials-pipeline-timeline-module__XQKmsq__cardLogo",
  "cardLogoStacked": "public-trials-pipeline-timeline-module__XQKmsq__cardLogoStacked",
  "cardRaised": "public-trials-pipeline-timeline-module__XQKmsq__cardRaised",
  "cardStage": "public-trials-pipeline-timeline-module__XQKmsq__cardStage",
  "cardStageStretch": "public-trials-pipeline-timeline-module__XQKmsq__cardStageStretch",
  "cardStretch": "public-trials-pipeline-timeline-module__XQKmsq__cardStretch",
  "ctrl": "public-trials-pipeline-timeline-module__XQKmsq__ctrl",
  "ctrlCentered": "public-trials-pipeline-timeline-module__XQKmsq__ctrlCentered",
  "ctrlHeaderAboveCard": "public-trials-pipeline-timeline-module__XQKmsq__ctrlHeaderAboveCard",
  "ctrlHeading": "public-trials-pipeline-timeline-module__XQKmsq__ctrlHeading",
  "ctrlHeadingAboveCard": "public-trials-pipeline-timeline-module__XQKmsq__ctrlHeadingAboveCard",
  "ctrlSubheadingAboveCard": "public-trials-pipeline-timeline-module__XQKmsq__ctrlSubheadingAboveCard",
  "emptyPromptCentered": "public-trials-pipeline-timeline-module__XQKmsq__emptyPromptCentered",
  "flushRoot": "public-trials-pipeline-timeline-module__XQKmsq__flushRoot",
  "pendingBand": "public-trials-pipeline-timeline-module__XQKmsq__pendingBand",
  "pendingBandHead": "public-trials-pipeline-timeline-module__XQKmsq__pendingBandHead",
  "pendingBandName": "public-trials-pipeline-timeline-module__XQKmsq__pendingBandName",
  "pendingBandNote": "public-trials-pipeline-timeline-module__XQKmsq__pendingBandNote",
  "pendingBands": "public-trials-pipeline-timeline-module__XQKmsq__pendingBands",
  "pendingBar": "public-trials-pipeline-timeline-module__XQKmsq__pendingBar",
  "pendingLabel": "public-trials-pipeline-timeline-module__XQKmsq__pendingLabel",
  "pendingLane": "public-trials-pipeline-timeline-module__XQKmsq__pendingLane",
  "pendingPulse": "public-trials-pipeline-timeline-module__XQKmsq__pendingPulse",
  "root": "public-trials-pipeline-timeline-module__XQKmsq__root",
  "rootCentered": "public-trials-pipeline-timeline-module__XQKmsq__rootCentered",
  "rootLightEmpty": "public-trials-pipeline-timeline-module__XQKmsq__rootLightEmpty",
  "rootRaisedInk": "public-trials-pipeline-timeline-module__XQKmsq__rootRaisedInk",
  "scopeNav": "public-trials-pipeline-timeline-module__XQKmsq__scopeNav",
  "scopeNavStacked": "public-trials-pipeline-timeline-module__XQKmsq__scopeNavStacked",
});
